var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcercise7Icon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 299,
    height: 349,
    viewBox: "0 0 299 349",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_di_478_12447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.24 41.9547C106.639 37.0582 99.2005 42.3702 102.564 47.4299C103.438 48.7653 104.402 50.0413 105.32 51.2729C116.39 66.2443 122.124 84.4206 127.059 102.374C128.274 106.826 129.444 111.5 128.066 115.847C130.052 104.185 128.763 92.1066 125.769 80.6666C122.776 69.2267 118.212 58.2764 113.337 47.4002C112.497 45.482 111.459 43.6569 110.24 41.9547Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4016 73.3961C30.9925 73.1587 29.9848 84.5097 37.4235 85.1032C39.3795 85.2515 41.3356 85.2961 43.2175 85.3554C66.0819 85.9786 87.672 94.2581 108.492 103.161C113.589 105.357 118.864 107.82 121.932 112.509C112.567 101.633 100.223 93.6646 87.1089 87.8037C73.9948 81.9427 60.0064 78.0997 46.0329 74.4496C43.5357 73.8175 40.9764 73.4642 38.4016 73.3961Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.4612 101.306C35.749 101.469 36.8159 108.191 41.5577 108.221C42.8025 108.221 44.0472 108.221 45.2326 108.132C59.6507 107.538 74.4245 111.529 88.7536 115.907C92.2804 116.99 95.9849 118.206 98.5484 120.848C90.9395 114.965 82.3152 110.534 73.1056 107.775C64.0385 105.074 54.7874 103.036 45.4253 101.677C43.7877 101.383 42.1242 101.259 40.4612 101.306Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.987 226.033C138.321 230.573 144.544 227.873 143.403 223.258C143.107 222.056 142.751 220.869 142.41 219.727C138.261 205.883 138.454 190.556 139.136 175.57C139.313 171.89 139.565 167.987 141.477 164.857C137.679 173.693 135.534 183.154 135.149 192.767C134.779 202.239 135.101 211.726 136.113 221.151C136.242 222.804 136.534 224.439 136.987 226.033Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.0558 35.619C46.2255 35.1293 46.0032 39.2691 48.8335 39.8923C49.5744 40.0555 50.3153 40.189 51.0414 40.3077C59.7248 41.7915 68.0379 46.05 76.0397 50.4865C78.1026 51.4326 79.8996 52.8752 81.2705 54.6856C77.4687 50.2028 72.8782 46.4561 67.7267 43.6314C62.6533 40.8699 57.3893 38.4749 51.9749 36.4647C51.03 36.0934 50.0528 35.8102 49.0558 35.619Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.2236 145.374C-1.97804 149.084 4.11222 159.278 11.5065 155.895C13.4477 155.004 15.3296 154.01 17.1374 153.075C39.1572 141.635 64.7186 137.436 89.8799 134.187C96.0443 133.4 102.624 132.703 108.343 135.151C92.7695 130.7 76.2028 130.388 60.1843 132.184C44.1658 133.979 28.5919 138.119 13.1661 142.318C10.4217 143.064 7.76044 144.088 5.2236 145.374Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.806 185.036C20.6197 189.873 28.7697 195.586 34.1339 190.971C35.6157 189.754 36.9049 188.464 38.2089 187.247C53.9754 172.409 74.8245 161.874 95.5848 152.141C100.682 149.752 121.65 147.318 127.251 147.452C112.626 148.758 82.7967 153.387 69.4604 159.322C56.4402 165.518 43.8554 172.592 31.7926 180.496C29.659 181.817 27.6546 183.338 25.806 185.036Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7329 248.364C61.2511 255.278 71.1052 255.382 72.9427 248.468C73.4168 246.658 73.8021 244.833 74.1726 243.096C78.7366 221.923 89.8947 201.358 101.453 181.549C104.298 176.682 120.168 162.735 124.851 159.663C113.559 169.071 91.5839 189.829 84.0859 202.367C76.8926 214.878 70.5508 227.861 65.1038 241.227C64.0885 243.525 63.2946 245.915 62.7329 248.364Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.061 5.26073C133.534 -1.93562 123.458 3.98471 126.688 11.374C127.533 13.3029 128.467 15.1873 129.37 16.9975C140.217 38.9871 143.952 64.4786 146.752 89.421C147.434 95.5638 148.012 102.093 145.522 107.731C150.071 92.344 150.679 75.9037 149.108 59.9827C147.537 44.0617 143.788 28.6007 139.876 13.1842C139.21 10.454 138.266 7.79912 137.061 5.26073Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.76 41.9547C184.361 37.0582 191.785 42.3702 188.436 47.4299C187.547 48.7653 186.598 50.0413 185.68 51.2729C174.61 66.2443 168.876 84.4206 163.926 102.374C162.711 106.826 161.541 111.5 162.934 115.847C160.948 104.185 162.237 92.1066 165.23 80.6666C168.224 69.2267 172.847 58.2764 177.648 47.4447C178.496 45.5136 179.539 43.6741 180.76 41.9547Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.584 73.3961C259.993 73.1587 261 84.5097 253.562 85.1032C251.62 85.2515 249.65 85.2961 247.783 85.3554C224.903 85.9786 203.328 94.2581 182.508 103.161C177.411 105.357 172.047 107.82 169.068 112.509C178.433 101.633 190.762 93.6646 203.891 87.8037C217.02 81.9427 230.979 78.0997 244.967 74.4496C247.459 73.8186 250.014 73.4653 252.584 73.3961Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.524 101.306C255.251 101.469 254.184 108.191 249.442 108.221C248.197 108.221 246.953 108.221 245.767 108.132C231.334 107.538 216.575 111.529 202.246 115.907C198.72 116.99 195 118.206 192.451 120.848C200.06 114.965 208.685 110.534 217.894 107.775C226.985 105.06 236.261 103.012 245.649 101.647C247.258 101.369 248.891 101.254 250.524 101.306Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.944 35.619C244.774 35.1293 244.997 39.2691 242.166 39.8923C241.426 40.0555 240.685 40.189 239.958 40.3077C231.275 41.7915 222.947 46.05 214.945 50.4865C212.887 51.4331 211.095 52.8758 209.729 54.6856C213.526 50.2033 218.111 46.4565 223.258 43.6314C228.338 40.8726 233.607 38.4777 239.025 36.4647C239.97 36.0934 240.947 35.8102 241.944 35.619Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.016 234.624C167.379 237.443 163.482 236.108 164.001 233.14C164.134 232.398 164.312 231.657 164.475 230.944C166.445 222.353 165.734 213.02 164.727 203.925C164.653 201.657 164.017 199.444 162.874 197.485C165.54 202.717 167.222 208.396 167.838 214.237C168.432 219.993 168.606 225.786 168.357 231.567C168.35 232.595 168.235 233.62 168.016 234.624Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.122 215.914C242.344 219.682 236.891 219.43 234.491 215.661C233.868 214.682 233.29 213.688 232.742 212.694C225.985 201.194 215.716 189.814 205.358 178.819C202.905 175.969 200.044 173.499 196.867 171.489C204.944 177.009 212.397 183.392 219.095 190.526C225.733 197.485 231.601 204.741 237.351 211.982C238.363 213.227 239.289 214.541 240.122 215.914Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.847 215.914C40.6243 219.682 46.0773 219.43 48.4631 215.661C49.1003 214.682 49.6782 213.688 50.2264 212.694C56.9835 201.194 67.2525 189.814 77.6104 178.819C80.0597 175.965 82.9217 173.495 86.1013 171.489C78.0218 177.005 70.5685 183.389 63.874 190.526C57.2355 197.485 51.3526 204.741 45.618 211.982C44.6053 213.227 43.6794 214.541 42.847 215.914Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.997 234.624C115.634 237.443 119.531 236.108 119.012 233.14C118.879 232.398 118.701 231.657 118.538 230.944C116.567 222.353 117.279 213.02 118.286 203.925C118.36 201.657 118.996 199.444 120.139 197.485C117.494 202.736 115.836 208.43 115.249 214.281C114.654 220.038 114.481 225.83 114.73 231.612C114.716 232.623 114.806 233.632 114.997 234.624Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.213 63.8851C222.043 63.3806 222.266 67.5203 219.435 68.1584C218.694 68.3216 217.954 68.4403 217.227 68.559C208.544 70.0427 200.231 74.3161 192.214 78.7526C190.156 79.6924 188.363 81.1303 186.998 82.9368C190.796 78.4543 195.388 74.7119 200.542 71.8975C205.61 69.1239 210.874 66.7285 216.294 64.7308C217.234 64.346 218.213 64.0625 219.213 63.8851Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.703 8.39154C195.148 6.90775 196.897 10.632 194.496 12.279C193.874 12.7093 193.222 13.0951 192.614 13.4809C185.102 18.1103 178.982 25.1731 173.217 32.2953C171.649 33.9293 170.522 35.9361 169.943 38.1266C171.791 32.5478 174.65 27.3572 178.374 22.8139C182.047 18.3507 186.039 14.1603 190.318 10.2759C191.049 9.57114 191.848 8.93999 192.703 8.39154Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.776 145.374C292.978 149.084 286.888 159.278 279.493 155.895C277.552 155.004 275.656 154.01 273.863 153.075C251.843 141.635 226.267 137.436 201.12 134.187C194.956 133.4 188.376 132.703 182.657 135.151C198.216 130.7 214.797 130.388 230.816 132.184C246.834 133.979 262.408 138.119 277.834 142.318C280.577 143.066 283.238 144.09 285.776 145.374Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.194 185.036C270.365 189.873 262.23 195.586 256.851 190.971C255.444 189.754 254.08 188.464 252.791 187.247C237.01 172.409 216.16 161.874 195.415 152.141C190.318 149.752 169.335 147.318 163.749 147.452C178.374 148.758 208.203 153.387 221.539 159.322C234.564 165.518 247.154 172.592 259.222 180.496C261.351 181.818 263.35 183.338 265.194 185.036Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.158 256.258C204.795 263.306 194.956 262.193 194.007 255.085C193.755 253.231 193.607 251.376 193.459 249.595C191.577 228.021 183.086 206.224 174.092 185.11C171.884 179.932 157.881 164.115 153.613 160.479C163.645 171.222 182.849 194.606 188.717 207.961C194.288 221.27 198.951 234.942 202.676 248.883C203.396 251.29 203.892 253.759 204.158 256.258Z",
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_478_12447)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M157.417 60.1152L80.5366 145.447H131.79V205.179L208.67 119.847H157.417V60.1152Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.5366 145.447L78.6793 143.774L74.9192 147.947H80.5366V145.447ZM157.417 60.1152H159.917V53.6055L155.56 58.4418L157.417 60.1152ZM131.79 145.447H134.29V142.947H131.79V145.447ZM131.79 205.179H129.29V211.689L133.647 206.853L131.79 205.179ZM208.67 119.847L210.528 121.521L214.288 117.347H208.67V119.847ZM157.417 119.847H154.917V122.347H157.417V119.847ZM82.394 147.12L159.274 61.7886L155.56 58.4418L78.6793 143.774L82.394 147.12ZM131.79 142.947H80.5366V147.947H131.79V142.947ZM134.29 205.179V145.447H129.29V205.179H134.29ZM206.813 118.174L129.933 203.506L133.647 206.853L210.528 121.521L206.813 118.174ZM157.417 122.347H208.67V117.347H157.417V122.347ZM154.917 60.1152V119.847H159.917V60.1152H154.917Z",
    fill: "#B7B7B7"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_di_478_12447",
    x: -2,
    y: -2,
    width: 301,
    height: 273.014,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_12447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_478_12447",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_478_12447"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_478_12447",
    x: 64.9194,
    y: 43.6055,
    width: 159.368,
    height: 178.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_478_12447"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -4,
    dy: -4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_478_12447",
    result: "effect2_dropShadow_478_12447"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_478_12447",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcercise7Icon);
export default __webpack_public_path__ + "static/media/excercise7icon.eb4bebc515c234945be972b2890d15f6.svg";
export { ForwardRef as ReactComponent };